import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Card } from "primereact/card";
import Footer from "../../components/layout/footer";
import { REILogo as Logo } from "../../images";

const SignupSuccess: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { plan } = location.state || {};

  if (!plan) {
    navigate("/pricing");
    return null;
  }

  return (
    <>
      <div className="signup-success min-h-screen bg-gradient-to-b from-gray-50 to-white py-6 sm:py-8 md:py-12 lg:py-16">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl">
          <Card className="shadow-lg border border-gray-200">
            <div className="text-center p-5 sm:p-6">
              <div className="mx-auto w-20 h-20 sm:w-24 sm:h-24 bg-emerald-100 rounded-full flex items-center justify-center mb-6">
                <svg
                  className="w-10 h-10 sm:w-12 sm:h-12 text-emerald-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <>
                <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 sm:mb-4 leading-tight">
                  Welcome to Real Estate Investar
                </h1>
                <h3 className="text-lg sm:text-xl md:text-2xl font-semibold text-gray-700 mb-6">
                  Your {plan} Membership is Now Active!
                </h3>
                <p className="text-base sm:text-lg text-gray-700 leading-relaxed max-w-3xl mx-auto mb-5">
                  Thank you for joining Real Estate Investar. Your paid membership has been successfully activated,
                  giving you full access to our comprehensive suite of property investment tools and insights.
                </p>

                <p className="text-base sm:text-lg text-gray-700 leading-relaxed max-w-3xl mx-auto mb-5">
                  Shortly, you will receive a welcome email containing your login details.
                </p>
              </>
              <div className="bg-amber-50 border border-amber-200 rounded-xl p-5 sm:p-6 text-left max-w-3xl mx-auto mb-6">
                <h2 className="text-lg sm:text-xl font-semibold text-gray-900 mb-2">
                  Didn’t receive your welcome email?
                </h2>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-4">
                  If it hasn’t arrived within a few minutes, please check your junk or spam folders.
                  <br /> If you still cannot locate it, please contact our support team and we’ll be happy to assist.
                </p>
                <div className="text-center">
                  <a
                    href="mailto:info@realestateinvestar.com.au?subject=Welcome%20Email%20Not%20Received"
                    id="signup-lnk-emailus"
                    data-testid="signup-lnk-emailus"
                    className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white font-medium py-2.5 px-5 rounded-lg transition-colors duration-200 text-sm sm:text-base"
                  >
                    <i className="pi pi-envelope" />
                    Send us an Email
                  </a>
                </div>
              </div>

              <p className="text-base sm:text-lg text-gray-700 leading-relaxed max-w-3xl mx-auto mb-8">
                Thank you for choosing Real Estate Investar. We look forward to supporting your investment success.
              </p>

              <h4 className="text-gray-900 font-semibold mb-8">The Real Estate Investar Team</h4>
              <img src={Logo} alt="REI Logo" className="" />
            </div>
          </Card>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default SignupSuccess;
